import makeStyles from '@mui/styles/makeStyles';

export const useAdminRolesStyles = makeStyles(() => ({
   panel: {
      height: '100%',
   },
}));
